module.exports = __webpack_public_path__ + "static/media/terms-zh-hant.10e5b440.md";